import { render, staticRenderFns } from "./reverse-relevance-list.vue?vue&type=template&id=b4b98598&scoped=true"
import script from "./reverse-relevance-list.vue?vue&type=script&lang=ts"
export * from "./reverse-relevance-list.vue?vue&type=script&lang=ts"
import style0 from "./reverse-relevance-list.vue?vue&type=style&index=0&id=b4b98598&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b98598",
  null
  
)

export default component.exports